<template>
  <div>
     <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col> -->
        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                :disabled="selectedRows.length > 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px"> mdi-file-plus-outline </v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="assignRemoveFormDialog(true)"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-plus-circle-multiple-outline</v-icon>
                <span class="lable_class">Assign</span>
              </v-btn>
            </template>
            <span>Assign form(s) on selected records</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="assignRemoveFormDialog(false)"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-delete-sweep</v-icon>
                <span class="lable_class">Remove</span>
              </v-btn>
            </template>
            <span>Remove form(s) from selected records</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="mergeAreaDialog()"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length <= 1"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-merge</v-icon>
                <span class="lable_class">Merge</span>
              </v-btn>
            </template>
            <span>Merge selected areas</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled
              class="ml-7 header_btn">
                <v-icon size="28px"> mdi-eye-outline </v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                @click="delete_dialog = true"
                class="ml-7 header_btn"
              >
                <v-icon size="28px"> mdi-delete-outline </v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="6">
           <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="setData({key : 'selected_alphabet',value : ''})" icon small dark v-bind="attrs" v-on="on" class="header_btn">
                
                  <span class="lable_class">Search</span>
                 <v-badge overlap dot :value="search" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="300">
              <v-row no-gutters>
            <v-col cols="12" class="">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
                solo
                clearable
                v-on:keyup.enter="search_menu = false"
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>
            </v-card>
           </v-menu>
           <v-menu bottom :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" disabled class="ml-7 header_btn">
                <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                <span class="lable_class">Filter</span>
              </v-btn>
            </template>
           </v-menu>
        </v-col>
        <v-col cols="2" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">Area<v-icon class="error--text ml-2" size="30" style="color:#ffffff  !important" @click="logout()" >mdi-logout</v-icon></span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
          <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
        </v-overlay>
    <v-card flat tile>
      
      <v-card-text
        class="pa-0 mx-auto"
      >
        <v-row dense="" class="pa-0 ma-0">
          <v-col cols="1" class="pa-0 ma-0" style="max-width: 2.5%;">
            <AlphabetSort />
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table small-table fix-table-layout fix-table-header custom-width-550"
              item-key="user_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              @item-expanded="expandRow"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td width="3%">
                    <v-icon @click="editRecord(item.area_id)">
                      mdi-clipboard-edit-outline
                    </v-icon>
                  </td>
                  <td width="7%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td width="36%">
                    {{item.name}}
                  </td>
                  <td width="50%">
                    <v-autocomplete
                      style="margin-top: -1px;"
                      :items="module_list"
                      dense=""
                      v-model="modules[items.data.indexOf(item)]"
                      hide-details=""
                      multiple=""
                      @change="changeFormModule(items.data.indexOf(item),item)"
                    >
                      <template v-slot:selection="{index}">                                         
                        <span class="grey--text caption" v-if="index == 0">
                          {{selected_modules(items.data.indexOf(item))}}
                        </span>
                      </template>
                    </v-autocomplete>
                  </td>
                </tr>
              </template>
              <template v-slot:header.select_all>
                <v-simple-checkbox
                  v-model="select_all_checkbox"
                  @input="changeSelectAll()"
                  color="white"
                  :ripple="false"
                  class="select-all-checkbox custom-simple-box"
                ></v-simple-checkbox>
              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Add Area</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="Name*"
                  v-model="form_data.name"
                  :error-messages="form_error.name"
                  :hide-details="!form_error.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-autocomplete
                  :items="module_list"
                  label="Form Name"
                  dense=""
                  v-model="form_data.modules"
                  :error-messages="form_error.modules"
                  :hide-details="!form_error.modules"
                  multiple=""
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{selected_multi_values}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="dialog = false;form_data = {};form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addRecord"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Update Area</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="Name*"
                  v-model="edit_form_data.name"
                  :error-messages="edit_form_error.name"
                  :hide-details="!edit_form_error.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-autocomplete
                  :items="module_list"
                  label="Form Name"
                  dense=""
                  v-model="edit_form_data.modules"
                  :error-messages="edit_form_error.modules"
                  :hide-details="!edit_form_error.modules"
                  multiple=""
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{selected_multi_values2}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error"
            @click="edit_dialog = false;edit_form_data = {};edit_form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateRecord" dark> Update </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline"> Confirmation </v-card-title>
        <v-card-text>
          Are you sure you want to delete selected areas?
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteRecords()">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="assign_remove_form_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">{{(is_assign_form)?'Assign Form(s)':'Remove Form(s)'}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  :items="module_list"
                  label="Form Name"
                  dense=""
                  v-model="selected_forms"
                  hide-details
                  multiple=""
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{selected_multi_values3}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="assign_remove_form_dialog = false;selected_forms = [];">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="selected_forms.length == 0" @click="assignRemoveForms"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="merge_area_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Merge Selected Areas</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="Name*"
                  v-model="merge_data.name"
                  :error-messages="merge_error.name"
                  :hide-details="!merge_error.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-autocomplete
                  :items="module_list"
                  label="Form Name"
                  dense=""
                  v-model="merge_data.modules"
                  :error-messages="merge_error.modules"
                  :hide-details="!merge_error.modules"
                  multiple=""
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{selected_multi_values4}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="merge_area_dialog = false;merge_data = {modules:[]};merge_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="mergeArea"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams, getAlphabets, logout } from "../../plugins/helper";
import AlphabetSort from "../AlphabetSort";
import { mapState,mapMutations } from "vuex";
export default {
  name: "Area",
  data() {
    return {
      merge_area_dialog: false,
      select_all_checkbox: false,
      dialog: false,
      edit_dialog:false,
      delete_dialog: false,
      is_assign_form: null,
      selected_forms: [],
      assign_remove_form_dialog: false,
      modules: [],
      form_data: {
        modules: []
      },
      merge_data: {
        modules: []
      },
      form_error: {},
      merge_error: {},
      edit_form_data: {
        modules: []
      },
      edit_form_error: {},
      search: "",
      area_id: null,
      form_loading:false,
      loading: false,
      items: {
        data: [],
      },
      headers: [
        { value: "", text: "", sortable: false, class:'', width: '7%' },
        { value: "select_all", text: "", sortable: false, width: '7%', class:'pl-0' },
        { value: "name", text: "Name", sortable: false, width: '36%' },
        { value: "", text: "Form Name", sortable: false, width:"50%" },
      ],
      module_list: [
        // { value: "DESIGN_WORK", text: "Design Work"},
        { value: "COUNTER_TOP_ORDER", text: "Counter Top Order"},
        // { value: "CABINET_ORDER", text: "Cabinet Order"},
        { value: "REMODELING", text: "Remodeling"},
        { value: "NEW_CONSTRUCTION", text: "New Construction"},
        // { value: "CLOSETS", text: "Closets"},
        { value: "RETAIL_SALES", text: "General Invoice"},
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["name"],
        page: 1,
        filters: {
          alphabet: "",
        },
      },
      alphabets: getAlphabets(),
      expanded: [],
      search_menu : false
    };
  },
  components: {
    AlphabetSort
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("submenu", ["selected_alphabet"]),
    selected_multi_values2() {
      let return_data = ''
      if(this.edit_form_data.modules.length > 0) {
        this.module_list.filter((item) => {
          if(item.value == this.edit_form_data.modules[0]) {
            return_data = item.text
          }
        })
        if(this.edit_form_data.modules.length > 1) {
          let totalVen = this.edit_form_data.modules.length - 1;
          return_data = return_data + ' ('+totalVen+' More)'
        }
      }
      return return_data;
    },
    selected_multi_values() {
      let return_data = ''
      if(this.form_data.modules.length > 0) {
        this.module_list.filter((item) => {
          if(item.value == this.form_data.modules[0]) {
            return_data = item.text
          }
        })
        if(this.form_data.modules.length > 1) {
          let totalVen = this.form_data.modules.length - 1;
          return_data = return_data + ' ('+totalVen+' More)'
        }
      }
      return return_data;
    },
    selected_multi_values3() {
      let return_data = ''
      if(this.selected_forms.length > 0) {
        this.module_list.filter((item) => {
          if(item.value == this.selected_forms[0]) {
            return_data = item.text
          }
        })
        if(this.selected_forms.length > 1) {
          let totalVen = this.selected_forms.length - 1;
          return_data = return_data + ' ('+totalVen+' More)'
        }
      }
      return return_data;
    },
    selected_multi_values4() {
      let return_data = ''
      if(this.merge_data.modules.length > 0) {
        this.module_list.filter((item) => {
          if(item.value == this.merge_data.modules[0]) {
            return_data = item.text
          }
        })
        if(this.merge_data.modules.length > 1) {
          let totalVen = this.merge_data.modules.length - 1;
          return_data = return_data + ' ('+totalVen+' More)'
        }
      }
      return return_data;
    },
    selectedRows() {
      return this.items.data.filter(function (item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "name";
      return paginationData;
    },
  },
  watch: {
    selected_alphabet(val) {
      this.pagination.filters.alphabet = val
    },
    search() {
      this.getRecords();
    },
    pagination: {
      handler: function () {
        this.getRecords();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("submenu", ["setData"]),
    ...mapMutations("utils", ["setAlert"]),
    mergeAreaDialog() {
      this.merge_area_dialog = true;
      for (let key in this.items.data) {
        if(this.items.data[key].selected) {
          for (let key2 in this.items.data[key].modules) {
            if(this.merge_data.modules.indexOf(this.items.data[key].modules[key2].form_code) == -1) {
              this.merge_data.modules.push(this.items.data[key].modules[key2].form_code)
            }
          }
        }
      }
    },
    assignRemoveForms() {
      let ids = []
      this.selectedRows.map(function(item){
        ids.push(item.area_id)
      })
      let _self = this;
      _self.form_loading = true;
      axios.post("assign_remove_area_form", {forms: this.selected_forms, is_assign_form: this.is_assign_form, ids: ids})
        .then(() => {
          _self.form_loading = false;
          _self.assign_remove_form_dialog = false
          _self.getRecords()
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    assignRemoveFormDialog(is_assign_form) {
      this.is_assign_form = is_assign_form;
      this.selected_forms = [];
      this.assign_remove_form_dialog = true;
    },
    changeSelectAll() {
      if (this.select_all_checkbox) {
        this.items.data = this.items.data.map((item) => {
          item.selected = true;
          return item;
        });
      } else {
        this.items.data = this.items.data.map((item) => {
          item.selected = false;
          return item;
        });
      }
    },
    changeFormModule(index,item) {
      let _self = this;
      this.loading = true;
      let data = {};
      data.area_id = item.area_id
      data.name  = item.name
      data.modules = this.modules[index]
      axios.post("update_area", data)
        .then(() => {
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    selected_modules(index) {
      let selected_modules = this.modules[index];
      let return_data = ''
      if(selected_modules.length > 0) {
        this.module_list.filter((item) => {
          if(item.value == selected_modules[0]) {
            return_data = item.text
          }
        })
        if(selected_modules.length > 1) {
          let totalVen = selected_modules.length - 1;
          return_data = return_data + ' ('+totalVen+' More)'
        }
      }
      return return_data;
    },
    editRecord(area_id) {
      this.area_id = area_id;
      this.edit_dialog=true;
      this.getDetails(area_id)
    },
    expandRow(itemData) {
      if(itemData.value) {
        this.items.data = this.items.data.map(function(item){
          if(item.user_id == itemData.item.user_id) {
            item.selected = true
          }
          return item
        })
      }
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getRecords() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios.get("area_list?" + url)
        .then((response) => {
          _self.items = response.data.data;
          _self.setData({key : 'alphabets',value : response.data.alphabets})
          let item_data = _self.items.data
          for (let key in item_data) {
            _self.modules[key] = []
            for (let key2 in item_data[key].modules) {
              _self.modules[key].push(item_data[key].modules[key2].form_code)
            }
          }
          _self.select_all_checkbox = false
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    addRecord() {
      let _self = this;
      _self.form_loading = true;
      axios.post("add_area", _self.form_data)
        .then((response) => {
          _self.form_data = {};
          _self.form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.form_loading = false;
            _self.dialog = false
            _self.getRecords()
          }
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    mergeArea() {
      this.merge_data.ids = []
      this.selectedRows.map((item) => {
        this.merge_data.ids.push(item.area_id)
      })
      let _self = this;
      _self.form_loading = true;
      axios.post("merge_area", _self.merge_data)
        .then((response) => {
          _self.merge_data = {modules:[]};
          _self.merge_error = {};
          let data = response.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.merge_error[key] = data.errors[key][0];
            }
          } else {
            _self.merge_area_dialog = false
            _self.getRecords()
          }
          _self.form_loading = false;
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    updateRecord(){
      let _self = this;
      _self.edit_form_data.area_id = _self.area_id
      axios.post("update_area", _self.edit_form_data)
        .then((response) => {
          _self.edit_form_data = {};
          _self.edit_form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.edit_form_error[key] = data.errors[key][0];
            }
          } else {
            _self.edit_form_data = {}
            _self.form_loading = false;
            _self.edit_dialog = false
            _self.getRecords();
          }
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    getDetails(area_id){
      let _self = this
      _self.form_loading= true;
      axios.get("get_area_details?area_id="+area_id)
        .then((response) => {
          let data = response.data.data;
          _self.edit_form_data.name = data.name;
          _self.edit_form_data.modules = []
          for(let key in data.modules) {
            _self.edit_form_data.modules.push(data.modules[key].form_code)
          }
          _self.form_loading = false;
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    deleteRecords(){
      let _self = this
      let ids = []
      this.selectedRows.map(function(item){
        ids.push(item.area_id)
      })
      axios.post("delete_areas",{
        ids : ids
      }).then(function(response){
        _self.setAlert({
          show: true,
          variant: response.data.variant,
          message: response.data.message,
          dismissCountDown: 0
        });
        _self.getRecords()
      })
      .catch(function(){
        console.log('FAILURE!!');
      });
    },
    logout() {
      logout(this.$router)
    }
  },
  mounted() {
    this.getRecords();
  },
};
</script>